import classNames from 'classnames';
import { Button } from 'odc-shared/components';
import React from 'react';

import website from '@src/constants/website';

import { UserGrowthCardSvg } from './UserGrowthCardSvg';

import './index.scss';

type UserGrowthCardProps = {
  animationEnabled?: boolean;
  skipAnimation?: boolean;
};
const UserGrowthCard: React.FC<UserGrowthCardProps> = ({ animationEnabled, skipAnimation }) => {
  return (
    <div
      className={classNames('odc-official-platform-card odc-user-growth-card', { 'animation-enabled': animationEnabled }, { 'skip-animation': skipAnimation })}
      onClick={() => { window.location.href = website.userGrowth; }}
    >
      <div className="odc-platform-card-header">
        <div className="header-content">
          <div className="title">User Growth</div>
          <div className="desc">Profitable growth for advertisers</div>
        </div>
        <div className="header-operate">
          <Button
            type="primary"
          >
            Get Now
          </Button>
        </div>
      </div>
      <div className="odc-platform-card-body">
        <UserGrowthCardSvg className="user-growth-card-svg" />
      </div>
    </div>
  );
};

export default UserGrowthCard;